module.exports = __webpack_public_path__ + "img/instagram-logo.afac8448.png";